import { mapDispatchIntroPage } from 'reg_redesign/redux/connectFunctions';
import IntroPage from 'reg_redesign/intro/IntroPage';

const page1 = {
  defaultNextPage: 'page-2',
  content: [
    {
      component: IntroPage,
      name: 'introPage',
      dispatchOverride: mapDispatchIntroPage,
      props: {
        id: 'introPage'
      }
    }
  ]
};

export default page1;
